export default __webpack_public_path__ + "static/media/icon.62ad2f1a.ico";